import './ChartGrid.css';
export var area = '_2c3zgm1-2-0-1';
export var plot = '_2c3zgm2-2-0-1';
export var plotLayout = '_2c3zgm0-2-0-1';